/**
 * Safely retrieves a nested value from an object using a dot separated string path.
 *
 * @template T - The type of the root object
 * @param obj - The object to extract the value from.
 * @param path - The dot separate key path (e.g. "phoneNumbers.home")
 * @param delimiter - Optional argument to split the path by a certain delimiter default to "."
 * @returns The value at the specified path, or undefined if not found.
 */
export var getValueFromPath = function (obj, path, delimiter) {
    if (delimiter === void 0) { delimiter = "."; }
    if (path === "") {
        return obj;
    }
    return path.split(delimiter).reduce(function (acc, key) {
        if (typeof acc === "object" && acc !== null && key in acc) {
            return acc[key];
        }
        return undefined;
    }, obj);
};
